/* @flow */
import Columns from 'components/Columns.jsx';
import GroupAvatarCluster from 'groups/components/GroupAvatarCluster.jsx';
import LinkConstants from 'constants/LinkConstants';
import OrganizationProfileTeacher from 'entities/OrganizationProfileTeacher';
import PropTypes from 'prop-types';
import * as React from 'react';

import './styles/SchoolTeacherListItem.scss';

class SchoolTeacherListItem extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    onGroupAvatarClick: PropTypes.func.isRequired,
    teacher: PropTypes.instanceOf(OrganizationProfileTeacher).isRequired,
  };

  render() {
    return (
      <div className="SchoolTeacherListItem">
        <Columns>
          <div className="SchoolTeacherListItem-signature">{this.props.teacher.getSignature()}</div>
          <GroupAvatarCluster
            groups={this.props.teacher.groupClusterItems}
            maxSize={3}
            moreButtonHref={LinkConstants.SIGN_UP}
            onGroupAvatarClick={this.props.onGroupAvatarClick}
          />
        </Columns>
      </div>
    );
  }
}

export default SchoolTeacherListItem;
